<template>
  <el-dialog
    title="Data"
    class="trend"
    :visible.sync="visible"
    width="60%"
    @close="$emit('update:show_trend', false)"
  >
    <el-row type="flex" justify="space-between">
      <el-col :span="12">
        <p>({{sml.gid}}){{sml.name}}</p>
      </el-col>
      <el-col :span="12" class="right">
        <label>Time:</label>
        <el-select
          class="ml-2"
          v-model="time_type"
          @change="getTrend()"
        >
        <el-option
          v-for="time in times"
          :value="time.value"
          :label="time.name"
          :key="time.name"
        ></el-option>
        </el-select>
      </el-col>
    </el-row>

    <el-table
      class="mt-2"
      empty-text="No Data"
      v-loading="loading"
      border
      :data="trendlist"
    >
      <el-table-column label="Geos">
        <template slot-scope="scope">
          <img
            class="flag-md"
            :src="
              `https://assets.ymcdn.net/app/images/flag/${scope.row.country.toLowerCase()}.png`
            "
          />
          {{scope.row.country}}
        </template>
      </el-table-column>
      <el-table-column prop="clk_os" label="OS"></el-table-column>
      <el-table-column prop="carrier_name" label="Carrier"></el-table-column>
      <el-table-column label="Avg Price($)" align="right">
        <template slot-scope="scope">
          {{scope.row.rpa.toFixed(2)}}
        </template>
      </el-table-column>
      <el-table-column label="Ecpm($)" align="right">
        <template slot-scope="scope">
          {{scope.row.aff_ecpc.toFixed(2)}}
        </template>
      </el-table-column>
    </el-table>
  </el-dialog>
</template>

<script>

export default {
  data() {
    return {
      visible: this.show_trend,
      loading: false,
      time_type: '1',
      trendlist: [],
      times: [
        { value: '1', name: 'Today' },
        { value: '2', name: 'Yesterday' },
        { value: '3', name: 'Last 3 Days' },
        { value: '4', name: 'Last 7 Days' },
      ],
    }
  },
  created() {
    this.getTrend()
  },
  props: {
    show_trend: {
      type: Boolean,
      default: false,
    },
    sml: {
      type: Object,
      default: () => {
        return {
          oid: '',
        }
      },
    },
  },
  watch: {
    show_trend() {
      this.visible = this.show_trend
    },
  },
  methods: {
    getTrend() {
      this.loading = true
      this.$http
        .get('/api/smartlink/get-offer-trend/', {
          params: {
            gid: this.sml.gid,
            relative: this.time_type,
          },
        })
        .then(res => {
          this.loading = false
          this.trendlist = res.data
        })
        .catch(err => {
          this.loading = false
          this.notifyOpen('Error', this.executeError(err), 'error')
        })
    },
  },
}
</script>

<style lang="scss">
.trend {
  .el-dialog__body {
    padding: 30px 40px;
  }

  .flag-md {
    margin-right: 14px;
    width: 28px;
    height: 16px;
  }

  .p {
    line-height: 32px;
  }

  .form-group {
    justify-content: space-between;
  }

  .el-select {
    width: auto
  }
}
</style>
